module.exports = __webpack_public_path__ + "static/media/icon01.3353a7b6.svg";